import * as React from 'react'

function SvgRotateLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.025 5c-.599 0-1.184.053-1.752.154l3.036 5.252a1.5 1.5 0 11-2.597 1.502L10 5.488c-.606-1.049-.154-2.485 1.107-2.885A12.94 12.94 0 0115.025 2C22.188 2 27.99 7.816 27.99 14.986c0 7.169-5.802 12.985-12.965 12.985-.05 0-.1-.002-.15-.007-.049.005-.098.008-.149.008-.4 0-.795-.018-1.185-.051a1.5 1.5 0 01.258-2.99c.304.027.613.04.927.04.05 0 .1.003.15.008.049-.005.099-.008.149-.008 5.501 0 9.965-4.468 9.965-9.985C24.99 9.468 20.526 5 15.025 5zM2.57 10.463a1.5 1.5 0 112.841.962c-.102.301-.19.601-.266.9a1.5 1.5 0 01-2.908-.735c.095-.376.206-.752.333-1.127zm-.545 7a1.5 1.5 0 012.95-.546c.113.61.28 1.2.496 1.766a1.5 1.5 0 11-2.802 1.072 13.08 13.08 0 01-.644-2.292zm3.977 7.189a1.5 1.5 0 112.02-2.218c.448.408.936.775 1.458 1.095a1.5 1.5 0 01-1.565 2.56 12.62 12.62 0 01-1.913-1.437z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgRotateLeft
